import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { DynamicFieldList } from '../../../types/dynamicFieldList';

export type DynamicFieldListState = {
  lists: DynamicFieldList[];
  fetchingLists: boolean;
  usedListIds: number[];
  usedEbpIds: number[];
};

const initialState: DynamicFieldListState = {
  lists: [],
  fetchingLists: false,
  usedListIds: [],
  usedEbpIds: [],
};

const reducer: Reducer<DynamicFieldListState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_DYNAMIC_FIELD_LISTS_PENDING':
      return {
        ...state,
        fetchingLists: true,
      };
    case 'FETCH_DYNAMIC_FIELD_LISTS_FULFILLED':
      return {
        ...state,
        fetchingLists: false,
        lists: action.payload.data,
      };
    case 'CREATE_DYNAMIC_FIELD_LIST_FULFILLED':
      return {
        ...state,
        lists: [action.payload.data, ...state.lists],
      };
    case 'DELETE_DYNAMIC_FIELD_LIST_FULFILLED':
      return {
        ...state,
        lists: state.lists.filter(list => list.id !== action.meta.id),
      };
    case 'FETCH_USED_DYNAMIC_VALUE_RESOURCES_FULFILLED':
      return {
        ...state,
        usedListIds: action.payload.data.list_ids || [],
        usedEbpIds: action.payload.data.ebp_ids || [],
      };
  }
  return state;
};

export default reducer;
